import { render } from "./FonteRequisito.vue?vue&type=template&id=64bc9e7c"
import script from "./FonteRequisito.vue?vue&type=script&lang=js"
export * from "./FonteRequisito.vue?vue&type=script&lang=js"

import "./FonteRequisito.vue?vue&type=style&index=0&id=64bc9e7c&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__